/**
 * RdSAP API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * The time an amount applies over.
 */
export type ApplicablePeriod = 'ANNUAL' | 'MONTHLY' | 'DAILY';

export const ApplicablePeriod = {
    Annual: 'ANNUAL' as ApplicablePeriod,
    Monthly: 'MONTHLY' as ApplicablePeriod,
    Daily: 'DAILY' as ApplicablePeriod
};

